import 'whatwg-fetch';


export const downloadComments = () => (
  (dispatch) => {
    fetch('/api/after-event-comment-list.json')
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (json.success) {
          dispatch({
            type: 'PARSE_COMMENT_LIST',
            eventCommentList: json.eventCommentList,
          })
        } else {
          throw json.errorMessage;
        }
      }).catch(err => {
        dispatch({
          type: 'COMMENT_ERROR',
          error: err,
        })
      })
  }
);



// WEBPACK FOOTER //
// ./src/actions/comment-action.js